import { render, staticRenderFns } from "./RunItems.vue?vue&type=template&id=1262d9b5"
import script from "./RunItems.vue?vue&type=script&lang=js"
export * from "./RunItems.vue?vue&type=script&lang=js"
import style0 from "./RunItems.vue?vue&type=style&index=0&id=1262d9b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports